import React from 'react';

const Contact = () => {
    return (
        <div>
            <h1 className="name mt-5 pt-5">Email here: istiakiqbal@gmail.com </h1>
        </div>
    );
};

export default Contact;